module.exports = __webpack_public_path__ + "media/images/static/benefit/fig_merit4-2_grand_prix-f1f21b3c391c83d1398d6e98b526ee4e.jpg";